export default __webpack_public_path__ + "static/media/headset.2977eaa3.png";